var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "duration" } },
    [
      _c("div", { staticClass: "material-icons time-icon" }, [
        _vm._v("timelapse"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("span", { staticClass: "time-label" }, [_vm._v("Randevu süresi")]),
          _vm._v(" "),
          _c("span", { staticClass: "time-sub-label" }, [
            _vm._v("Her randevu ne kadar sürmelidir?"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "time-select",
              attrs: { "show-search": "" },
              model: {
                value: _vm.duration,
                callback: function ($$v) {
                  _vm.duration = $$v
                },
                expression: "duration",
              },
            },
            _vm._l(_vm.remindDates, function (remindDate, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: remindDate.value } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(remindDate.label) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              staticStyle: { width: "50vw" },
              attrs: {
                id: "duration-modal",
                showTitle: false,
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "new-form-item" }, [
                _vm._v("Custom duration"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.customDuration,
                        expression: "customDuration",
                      },
                    ],
                    staticClass: "input-number",
                    attrs: { type: "number", min: "1" },
                    domProps: { value: _vm.customDuration },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.customDuration = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticClass: "select-item",
                      model: {
                        value: _vm.selectedType,
                        callback: function ($$v) {
                          _vm.selectedType = $$v
                        },
                        expression: "selectedType",
                      },
                    },
                    _vm._l(_vm.types, function (type, i) {
                      return _c(
                        "a-select-option",
                        { key: i, attrs: { value: type.value } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(type.label) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "footer" }, [
                _c(
                  "span",
                  {
                    staticClass: "footer-btn",
                    on: {
                      click: function ($event) {
                        _vm.showModal = false
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "footer-btn",
                    on: {
                      click: function ($event) {
                        return _vm.saveCustomDuration()
                      },
                    },
                  },
                  [_vm._v("Save")]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }